import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

const getIsLoading = (loadingIndicators: boolean[]): boolean =>
  loadingIndicators.some((isLoading) => isLoading);

const debouncedSetIsLoading = debounce(
  (
    loadingIndicators: boolean[],
    setIsLoading: (isLoading: boolean) => void
  ) => {
    setIsLoading(getIsLoading(loadingIndicators));
  },
  200
);

const useDebouncedIsLoading = (
  loadingIndicators: boolean[],
  initialState = true
) => {
  const [isLoading, setIsLoading] = useState(initialState);

  useEffect(() => {
    debouncedSetIsLoading(loadingIndicators, setIsLoading);
  }, [loadingIndicators]);

  return isLoading;
};

export { useDebouncedIsLoading };
